import React, {useEffect, useRef, useCallback, useState} from 'react'
import { useDrop } from 'react-dnd'

// Class is untested do not use. 

function useAccessibleDrop (props) {
    const [collection, refCallback] = useDrop(props)
    const dropRef = useRef(null)
    const setDropRef = useCallback (node => {
        dropRef.current = node?.current || node
        return refCallback(node)
    },[])
    return [collection, setDropRef]
}

export default useAccessibleDrop